import React from 'react';
import { NavItem } from './NavItem';
import type { NavItemType } from '../../types/navigation';

interface DesktopMenuProps {
  items: readonly NavItemType[];
  currentPath: string;
}

export const DesktopMenu: React.FC<DesktopMenuProps> = ({ items, currentPath }) => {
  return (
    <div className="hidden md:flex space-x-8 py-3">
      {items.map((item) => (
        <NavItem
          key={item.path}
          item={item}
          isActive={currentPath === item.path}
        />
      ))}
    </div>
  );
};